import * as React from 'react';
import { useScroll } from './hooks';
import { useDispatch, useSelector } from 'react-redux';
import { applyFilters } from '../../actions/filters';
import { useEventCallback } from '@cian/react-utils';
import { LocationPickerContainer, AreaContainer, SearchTooltipProvider, PriceContainer } from './containers';
import { Filters, SearchButton } from '../../components/Filters';
import { selectFiltersMeta } from '../../selectors/filters';
import { EFiltersMetaStatus } from '../../types/filters';
import { FloorsContainer } from './containers/FloorsContainer';
import { MaterialsContainer } from './containers/MaterialsContainer';

export const FiltersContainer = () => {
  const dispatch = useDispatch();
  const filtersRef = React.useRef<HTMLDivElement>(null);
  const position = useScroll(filtersRef);

  const { status } = useSelector(selectFiltersMeta);

  const handleSearch = useEventCallback(() => {
    dispatch(applyFilters());
  });

  return (
    <Filters ref={filtersRef} position={position}>
      <SearchTooltipProvider>
        <LocationPickerContainer />
        <PriceContainer />
        <AreaContainer />
        <FloorsContainer />
        <MaterialsContainer />
      </SearchTooltipProvider>
      <SearchButton onClick={handleSearch} loading={status === EFiltersMetaStatus.Pending} />
    </Filters>
  );
};
